import { createStyles, makeStyles } from "@material-ui/core/styles";


export const useHeaderStyles = makeStyles(theme =>
    createStyles({
        locationName: {
            fontWeight: "bolder",
        },
        placeholder: {
            width: "10em",
        },
        head: {
            maxWidth: "90%",
            marginLeft: "1.5em",
        },
        secondaryInfo: {
            fontSize: "1.125rem",
            color: theme.palette.grey[700],
        },
    }),
);
